var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7544",
    "data-name": "Group 7544",
    transform: "translate(-35 -210)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(35 210)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("g", {
    id: "click",
    transform: "translate(49.631 221.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M15.23,64.669A1.754,1.754,0,0,0,13.868,63a1.929,1.929,0,0,0-1.065.054,1.851,1.851,0,0,0-2.4-1.17,1.852,1.852,0,0,0-2.294-1.14V60.5c0-.569.009-1.138,0-1.706a1.805,1.805,0,1,0-3.609.128q0,3.721,0,7.442v.214a10.275,10.275,0,0,1-.636-.871A2.122,2.122,0,0,0,.322,68.046q1.568,2.508,3.168,5A3.964,3.964,0,0,0,5.43,74.63a11.714,11.714,0,0,0,1.283.343h4.318a1.7,1.7,0,0,1,.179-.039,4.611,4.611,0,0,0,3.972-3.9,12.961,12.961,0,0,0,.055-1.518c0-1.617.011-3.235-.007-4.852ZM14,70.28a3.358,3.358,0,0,1-2.542,3.346,3.517,3.517,0,0,1-.832.108c-1.178.012-2.357.017-3.536,0a3.012,3.012,0,0,1-2.63-1.457c-1.031-1.608-2.05-3.224-3.071-4.839a.889.889,0,0,1,.664-1.405.857.857,0,0,1,.818.414q1.346,2,2.7,4.005c.038.056.078.111.117.167l.043-.009v-.24q0-5.664,0-11.327a1.5,1.5,0,0,1,.025-.326.558.558,0,0,1,.589-.439.576.576,0,0,1,.528.515,2.216,2.216,0,0,1,0,.226V65H8.112v-.217c0-.761,0-1.521,0-2.282a.572.572,0,1,1,1.143-.019c0,.055,0,.11,0,.165V65h1.223c0-.066.009-.138.009-.209,0-.39,0-.781,0-1.172a.57.57,0,1,1,1.138-.027c.013.39,0,.781,0,1.172V65h1.221c.006-.1.009-.2.018-.3A.565.565,0,0,1,14,64.71c0,.054,0,.11,0,.164,0,1.8,0,3.6,0,5.407Z",
    transform: "translate(0.006 -53.917)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M104.264,0H103.03V1.693h1.234Z",
    transform: "translate(-97.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M52.62,14.541,51.471,13.28l-.911.831,1.148,1.26Z",
    transform: "translate(-47.787 -12.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M164.124,63.5l1.7-.156-.112-1.228-1.7.158c.038.415.074.8.113,1.225Z",
    transform: "translate(-155.016 -58.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M33.1,62.229,31.4,62.07,31.29,63.3l1.7.156c.038-.418.073-.815.11-1.226Z",
    transform: "translate(-29.574 -58.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M142.268,14.111l-.911-.831-1.148,1.263.91.829,1.148-1.261Z",
    transform: "translate(-132.521 -12.552)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandIcon);
export default __webpack_public_path__ + "static/media/Hand-icon.0ced00de1c1d2e88393e2bea626d1f80.svg";
export { ForwardRef as ReactComponent };